export { StatusType, HandlerType, Logger } from './logger';
export { datadogLogs } from './logs.entry';
//# sourceMappingURL=index.js.map